<template>
	<div v-loading="fullscreenLoading" element-loading-text="拼命加载中..." element-loading-spinner="el-icon-loading"
		element-loading-background="rgba(0, 0, 0, 0.8)" class="mobile" oncontextmenu="return false"
		ondragstart="return false" onbeforecopy="return false">

		<!-- 
	 oncontextmenu="return false" 鼠标右键禁止
	 ondragstart="return false" 
	 onselectstart="return false" 禁止复制
	 onbeforecopy="return false"
	 -->
		<!-- 头部 start -->
		<header id="header" class="header" :class="[header_active==true?css_header_fix:css_header_down]">

			<div class="container">
				<div class="row header-body">
					<div class="logo">
						<a href="#" id="logo" @click="fun_url('home',1,'')">
							<img class="logo-image" src="@/assets/img/logo.png" alt="Organik Logo" />
						</a>
						<span>领科软件服务</span>
						<label class="iconfont icon-tuodong s-menu-top" @click="fun_show_menu()"></label>
					</div>

					<div class="search-btn">
						<input class="s-input" v-model="wordkey" placeholder="使用帮助:请输入查询关键字后点击搜索或回车"
							@keyup.enter="fun_search()" />
						<label class="iconfont icon-sousuo blink s-menu" @click="fun_search()"></label>
						<span class="s-txt" @click="fun_show_kefu">问题反馈</span>
					</div>

					<div class="login-name">
						<span class="s1">{{ logindata }}:</span>
						<span class="s2">您好</span>
						<span class="s3" @click="fun_show_allset">全局设置</span>
					</div>

				</div>
			</div>
		</header>

		<!-- 头部 end -->
		<div id="mright_menu" class="mright_menu" :class="[header_active==true?css_menu_top:css_menu_down]">
			<pre-menutop ref="my_top" @my-menu-top="fun_refresh_left" />
		</div>

		<el-container id="mybody" class="mybody">
			<div id="mleft" class="left" :class="[is_show==true?css_left_ok:css_left_no]">
				<pre-menuleft class="left_menu" @my-menu-left="fun_refresh_top" ref="my_push" v-show="is_show"
					:pre_left_data="left_data" />
			</div>

			<div id="mright" class="right" :class="[is_show==true?css_right_ok:css_right_no]">



				<div id="mright_down" class="mright_down">
					<!--
		  使用keep-alive后，单页应用会不刷新，必须取消对应缓存
		  <keep-alive>
		    <router-view ref="my_edit" v-if="isReload"></router-view>
		  </keep-alive>
		  -->
					<keep-alive>
						<router-view v-if="$route.meta.keepAlive">
							<!-- 这里是会被缓存的视图组件，比如 Home！ -->
						</router-view>
					</keep-alive>

					<router-view v-if="!$route.meta.keepAlive">
						<!-- 这里是不被缓存的视图组件，比如 Edit！ -->
						<router-view ref="my_edit" v-if="isReload"></router-view>
					</router-view>



				</div>
			</div>


		</el-container>

		<pretan ref="mypop">
			<template slot="tancontent">
				<div class="tan-set">
					<div>
						<h5>全局设定</h5>
					</div>
					<div>
						<preselect :inData="checkJson(fontstyle)" @com-event="refresh_view_edit" />
					</div>
					<div>
						<preselect :inData="checkJson(fontsize)" @com-event="refresh_view_edit" />
					</div>
					<div>
						<preradio :inData="checkJson(isFull)" @com-event="refresh_view_edit" />
					</div>
				</div>

			</template>
		</pretan>

		<!-- mypopkefu -->
		<pretan ref="mypopkefu">
			<template slot="tancontent">
				<div class="tan-set">
					<div>
						<h5>问题反馈</h5>
					</div>
					<div class="kf-erweima">
						<img src="https://image.haojun.work/sys/kefu.jpg" />
					</div>
					<div class="kf-row">
						<span>QQ:</span><label>1215739819&nbsp;&nbsp;591147671</label>
					</div>
					<div class="kf-row">
						<span>QQ群:</span><label>512259625</label>
					</div>
					<div class="kf-row">
						<span>响应时间:</span><label>周一至周五<br>早上9:00-12:00&nbsp;&nbsp;&nbsp;&nbsp;下午14:00-17:00</label>
					</div>
					<div class="kf-row">
						<h5 class="red">注意:截图反馈时请将菜单和问题也截取上!</h5>
					</div>
				</div>

			</template>
		</pretan>

		<pre-happy></pre-happy>
		<!-- 放这里，组件里就会有多个，然后就报错了，不知道执行那个 -->
		<div id="pre_tan_msg" style="display:none;"></div>


	</div>
</template>
<script>
	import api from '@/utils/type.js'


	import {
		sysSelect
	} from '@/utils/systemSelect.js';
	import {
		Message,
		checkStringByForm,
		GetRandom,
		GoUrl
	} from '@/utils/method.js';

	import mystore from "@/utils/localstore.js";

	import {
		Method_EasySelect,
		Sel_Mobile
	} from '@/utils/loadhttpdata.js';
	import type from '@/utils/type.js';

	export default {
		provide() {
			return {
				reload: this.reload
			};
		},
		components: {
			'pre-menuleft': () => import("./per_old/pre_menu_left.vue"),
			'pre-menutop': () => import("./per_old/pre_menu_top.vue"),
			'pre-happy': () => import("./per_old/pre_happy.vue")
		},
		data() {
			return {
				isReload: true, //强制刷新


				menu: [],
				fullscreenLoading: false,
				header_active: false,
				css_header_fix: 'header_fix',
				css_header_down: 'header_down',

				css_menu_top: 'menu-top-ok',
				css_menu_down: 'menu-top-no',

				showMenu: false,
				showLogin: false,
				showRegin: false,
				showForget: false,
				sendvalue: '获取验证码',
				user_acc: '',
				user_pwd: '',
				inputcode: '',
				logincode: '',
				t_phone: '',
				t_email: '',

				my_cnzz: '',

				logindata: '',

				// 菜单
				is_show: true,
				css_left_no: 'left_no',
				css_left_ok: 'left_ok',
				css_right_no: 'right_no',
				css_right_ok: 'right_ok',
				show_menu: true,
				show_menu_img: require("@/assets/image/showno_menu.png"),
				show_top: false,
				show_top_note: false,
				top_data: [],
				left_data: [],
				refresh_key: '',

				wordkey: '',

				fontstyle: [],
				fontsize: [],
				isFull: []


			};
		},
		created: function() {

			this.init();
			this.loadData();
			this.chang_style();

		},
		mounted: function() {
			const that = this;
			// 滚动事件 scroll
			// 变形事件 resize


			window.addEventListener('scroll', function() {
				// console.log('滚动');
				var scrolltop = $(document).scrollTop(); //获取当前窗口距离页面顶部高度

				// var topbar_height = document.getElementById('header').clientHeight;
				// console.log('topbar=' + topbar_height + '滚动' + scrolltop);
				if (scrolltop >= 16) {
					that.header_active = true;
				} else {
					that.header_active = false;
				}
			}, false);
		},
		methods: {
			reload: function() {
				this.isRouterAlive = false;
				this.$nextTick(function() {
					this.isRouterAlive = true;
				});
			},
			chang_style: function() {
				this.$nextTick(function() {
					let temp_height = $(window).height(); //当前浏览器窗口的 宽高
					// console.log('height=' + temp_height);
					let header_height = document.getElementById('header').offsetHeight; //头部高度
					// console.log('header_height=' + header_height)
					let th = 0;
					// th = temp_height - 60 - 10;
					th = temp_height - Number(header_height) - 8 - 42;
					// 42是小菜单
					let css = '';
					css = 'height: ' + th + 'px;min-height: ' + th + 'px;max-height: ' + th + 'px;';
					document.getElementById('mybody').style.cssText = css;
				});
			},
			checkJson: function(d) {
				let temp = '';
				temp = JSON.stringify(d)
				return temp;
			},
			refresh_view_edit: function(d) {
				// console.log(d);
				switch (d.key) {
					case 'font_style':
						// console.log('字体设定=' + d.val + ' =' + d.sel_name);
						this.chang_font_style(d.sel_name);
						break;
					case 'font_size':
						// console.log('字体大小=' + d.val + ' =' + d.sel_name);
						this.chang_font_size(d.sel_name);
						break;
					case 'full_screen':
						var content = document.getElementById('app');
						if (d.val == '1') {
							this.fullScreen(content);
						} else {
							this.exitFullScreen();
						}
						this.chang_style();
						break;
					case 'traning_flag':
						this.trans_istraning.val = d.val;
						break;
				}


			},
			init: function() {
				this.fontstyle = {
					"name": "字体设定",
					"val": "",
					"key": "font_style",
					"type": "select",
					"list": [{
							"id": "1",
							"val": "宋体"
						},
						{
							"id": "2",
							"val": "微软雅黑"
						},
						{
							"id": "3",
							"val": "MingLiU"
						},
						{
							"id": "4",
							"val": "PMingLiU"
						},
						{
							"id": "5",
							"val": "Tahoma"
						},
						{
							"id": "6",
							"val": "Arial"
						},
						{
							"id": "7",
							"val": "楷体"
						},
						{
							"id": "8",
							"val": "黑体"
						},
						{
							"id": "9",
							"val": "华文细黑"
						},
						{
							"id": "10",
							"val": "华文黑体"
						},
						{
							"id": "11",
							"val": "Helvetica"
						},
						{
							"id": "12",
							"val": "Georgia"
						},
						{
							"id": "13",
							"val": '华文黑体'
						},
						{
							"id": "14",
							"val": "黑体-简"
						},
						{
							"id": "15",
							"val": '冬青黑体'
						},
						{
							"id": "16",
							"val": 'Verdana'
						},
					],
					"sel_action": "",
					"sel_name": "",
					"p": "1",
					"w": "0",
					"r": "0"
				};
				this.chang_font_style();
				console.log('fontstyle=' + this.fontstyle.val);
				this.fontsize = {
					"name": "字体大小",
					"val": "",
					"key": "font_size",
					"type": "select",
					"list": [{
							"id": "1",
							"val": "12px"
						},
						{
							"id": "2",
							"val": "13px"
						},
						{
							"id": "3",
							"val": "14px"
						},
						{
							"id": "4",
							"val": "15px"
						},
						{
							"id": "5",
							"val": "16px"
						},
						{
							"id": "6",
							"val": "17px"
						},
						{
							"id": "7",
							"val": "18px"
						},
						{
							"id": "8",
							"val": "19px"
						},
						{
							"id": "9",
							"val": "20px"
						}
					],
					"sel_action": "",
					"sel_name": "",
					"p": "1",
					"w": "0",
					"r": "0"
				};
				this.chang_font_size();

				this.isFull = {
					"name": "是否全屏",
					"val": "2",
					"key": "full_screen",
					"type": "radio",
					"list": [{
						"id": "1",
						"val": "开启全屏"
					}, {
						"id": "2",
						"val": "退出全屏"
					}],
					"sel_action": "",
					"sel_name": "",
					"p": "1",
					"w": "0",
					"r": "0"
				};

			},
			fun_search: function() {
				if (typeof(this.wordkey) === 'undefined' || this.wordkey == '') {
					this.$message({
						message: '查询关键字不能为空!',
						type: 'success'
					});
					return;
				}

				let t = JSON.parse(localStorage.getItem('userdata'));
				// console.log(t);

				this.$post(
					api.http_method,
					Method_EasySelect('sys_val_search_url')
				).then(res => {
					res = JSON.parse(res);
					// console.log(res);
					if (res.data.status == 1) {
						let temp_url = res.data.data[0].sys_val;
						// console.log('url=' + temp_url);
						temp_url = temp_url + '&wordkey=' + this.wordkey + '&username=' + t[0].uname;
						// console.log('url=' + temp_url);
						// location.assign(temp_url,'blank');
						window.open(temp_url, 'blank');

					} else {
						this.$message({
							message: res.data.msg,
							type: 'warning'
						});
					}

				});
			},
			loadstyle: function() {
				// 初始化全局颜色
				this.$post(
					api.http_method, Method_EasySelect('data_css_style', GetRandom())
				).then(res => {
					res = JSON.parse(res);
					if (res.data.status == 1) {
						this.GLOBAL.cg = res.data.data[0].s_val;

						// var o = {};
						// o.background = this.GLOBAL.cg + " !important";
						// this.ok_backgroud = o;
						this.GLOBAL.ok_sel_background = this.ok_backgroud;

						// var p = '';
						// p = '2px solid ' + this.GLOBAL.cg;
						// this.ok_borderbottom = {
						//   'border-bottom': p
						// };
						this.GLOBAL.ok_sel_borderbottom = this.ok_borderbottom;
						// console.log(this.css_style);

						this.GLOBAL.ok_sel_input = {
							border: '1px solid ' + this.GLOBAL.cg,
							color: this.GLOBAL.cg
						}
					} else {}
				});
			},
			loadData: function() {
				let t = (localStorage.getItem('userdata'));
				if (t == null || t === undefined || t == '') {
					alert('登录信息已经过期,请重新登录!');
					location.href = '/login';
					return;
				} else {
					t = JSON.parse(t);
					// console.log(t);
					this.logindata = '[' + t[0].uno + ']' + t[0].uname;
				}
			},
			fun_url: function(parm, index, wordkey) {
				// console.log('goto  ==', parm);
				// this.$router.push("/" + parm + "/" + GetRandom());

				GoUrl(this, parm, wordkey, index);
			},
			// 菜单左右布局
			fun_refresh_top: function(tempdata) {
				// console.log(tempdata);
				// this.top_data = tempdata;
				// this.refresh_key = Math.random() + '';
				console.log('刷新上边...');

				this.header_active = true;
				this.$refs['my_top'].loadData(tempdata);
			},
			fun_refresh_left: function(tempdata) {
				this.left_data = tempdata;
				// console.log('刷新右边...', tempdata);
				if (tempdata.length == 0) {
					this.header_active = false;
				}
				this.reload();
			},
			fun_refresh_push: function(path, parm) {
				// console.log('推送刷新连接='+path);
				// console.log(this.$refs['my_push']);
				this.$refs['my_push'].refreshPush(path, parm);

			},
			fun_show_menu: function() {
				this.is_show = this.is_show == true ? false : true;

				let that = this;
				setTimeout(function() {
					try {
						that.$refs['my_edit'].$refs['file_table'].chang_style();
					} catch (e) {
						// console.log('刷新表格属性出错!');
					}
				}, 800);

			},
			/////////////////////////////////////////////////////////
			fun_show_allset: function() {
				this.$refs.mypop.showpop();
			},
			fun_show_kefu: function() {
				this.$refs.mypopkefu.showpop();
			},
			//进入全屏
			fullScreen: function(el) {
				var rfs = el.requestFullScreen || el.webkitRequestFullScreen || el.mozRequestFullScreen || el
					.msRequestFullScreen,
					wscript;

				if (typeof rfs != "undefined" && rfs) { ////////
					rfs.call(el);
					return;
				}

				if (typeof window.ActiveXObject != "undefined") {
					wscript = new ActiveXObject("WScript.Shell");
					if (wscript) {
						wscript.SendKeys("{F11}");
					}
				}
			},
			exitFullScreen: function() {
				//退出全屏
				var el = document,
					cfs = el.cancelFullScreen || el.webkitCancelFullScreen || el.mozCancelFullScreen || el
					.exitFullScreen,
					wscript;

				if (typeof cfs != "undefined" && cfs) {
					cfs.call(el);
					return;
				}

				if (typeof window.ActiveXObject != "undefined") {
					wscript = new ActiveXObject("WScript.Shell");
					if (wscript != null) {
						wscript.SendKeys("{F11}");
					}
				}
			},
			chang_font_style: function(val) {
				let f_style = '';
				if (typeof(val) === 'undefined' || val == '') {
					let t = (localStorage.getItem('my_font_style'));
					if (typeof(t) !== 'undefined' && t != '') {
						f_style = t;
					}
				} else {
					localStorage.setItem('my_font_style', val);
					f_style = val;

				}
				// console.log('当前字体=' + f_style);
				if (typeof(f_style) !== 'undefined' && f_style != '') {
					this.fontstyle.sel_name = f_style;
					// 开始设置
					console.log('当前设置字体=' + f_style);
					let css = '';
					css = 'font-family: ' + f_style +
						',-apple-system,SF UI Text,Arial,PingFang SC,Hiragino Sans GB,Microsoft YaHei,WenQuanYi Micro Hei,sans-serif';
					document.getElementById('app').style.cssText = css;
				}
			},
			chang_font_size: function(val) {
				let f_size = '';
				if (typeof(val) === 'undefined' || val == '') {
					let t = (localStorage.getItem('my_font_size'));
					if (typeof(t) !== 'undefined' && t != '') {
						f_size = t;
					}
				} else {
					localStorage.setItem('my_font_size', val);
					f_size = val;

				}

				// console.log('当前字体=' + f_size);
				if (typeof(f_size) !== 'undefined' && f_size != '') {
					this.fontsize.sel_name = f_size;
					// 开始设置
					// console.log('当前设置字体大小=' + f_size);
					let css = '';
					css = 'font-size: ' + f_size;
					document.getElementById('app').style.cssText = css;

					// let c2=document.getElementsByClassName('el-select-dropdown__item');
					// c2.style.cssText = css;
					// .el-month-table td .cell
				}
			},
			addClass: function(element, value) {
				if (!element.className) {
					element.className = value;
				} else {
					newClassName = element.className;
					newClassName += " "; //这句代码追加的类名分开
					newClassName += value;
					element.className = newClassName;
				}
			}

		}
	};


	// document.write(unescape(
	//   "%3Cspan id='cnzz_stat_icon_1278850266'%3E%3C/span%3E%3Cscript src='https://s9.cnzz.com/z_stat.php%3Fid%3D1278850266%26online%3D1' type='text/javascript'%3E%3C/script%3E"
	// ));
</script>


<style scoped>
	/* 头部 start */
	.header {
		width: 100%;
		margin-top: 0px;
		margin-bottom: 0px;
		background-color: rgb(255, 255, 255);
		/* background-color: #7fca90; */
		position: relative;
		z-index: 99;
		-webkit-transition: all 0.5s;
		-moz-transition: all 0.5s;
		-ms-transition: all 0.5s;
		-o-transition: all 0.5s;
		transition: all 0.5s;
		text-align: center;
	}


	.header>.container,
	.footer>.container {
		/* min-width: 1200px; */
		/* max-width: 1200px; */
		padding-right: 15px;
		padding-left: 15px;
		margin-right: auto;
		margin-left: auto;
	}

	.header>.container>.row {
		/* margin-right: -15px; */
		/* margin-left: -15px; */
		margin: 0px;
		width: 100%;
	}

	.header-body {
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: space-between;
	}

	.header>.container>.row>.logo {
		display: inline-flex;
		height: 36px;
		overflow: hidden;
		align-items: center;
		justify-content: flex-start;
	}

	.header>.container>.row>.logo>a>img {
		width: auto;
		height: 36px;
	}

	.header>.container>.row>.logo>span {
		display: flex;
		vertical-align: top;
		font-weight: 500;
		color: #000000;
		font-size: 18px;
		align-items: center;
		height: 36px;
	}

	.s-menu-top {
		display: flex;
		height: 36px;
		width: 28px;
		color: #606266;
		text-align: right;
		font-family: texticons;
		cursor: pointer;

		justify-content: center;
		align-items: center;
		font-size: 24px;
	}

	.header>.container>.row>.menu_list {
		display: inline-block;
		width: calc(100% - 30%);
		height: 36px;
		line-height: 36px;
		vertical-align: top;
		margin-top: -15px;
		text-align: center;
	}

	.menu {
		/* font-family: Lato, Helvetica, Arial, sans-serif; */
		font-weight: 700;
		font-style: normal;
		/* line-height: 1.5; */
		letter-spacing: 0em;
		font-size: 14px;
		display: inline-block;
	}


	.login-name {
		display: flex;
		font-size: 16px;
	}

	.login-name .s3 {
		padding: 2px 6px 2px 6px;

		display: inline-flex;
		background: #070f93;
		color: #fff;

		vertical-align: top;
		height: 100%;

		margin-bottom: 2px;
		border-bottom: 1px solid #000000;
		margin-left: 8px;
		border-radius: 5px;
		font-size: 12px;
	}

	.login-name .s3:hover {
		cursor: pointer;
		background: #0a18d9;
		color: #d0d0d0;
	}

	.header_fix {
		position: fixed;
		top: 0px;
		right: 0px;
		padding: 1px 0;
		animation: gotop 0.6s;
		-webkit-animation: gotop 0.6s;
		/* Safari and Chrome */
		background-color: #fff;
		opacity: 0.9;
		box-shadow: 0px 5px 5px #888888;
	}

	@keyframes gotop {
		from {
			padding: 16px 0;
		}

		to {
			padding: 1px 0;
		}
	}

	@-webkit-keyframes gotop

	/* Safari and Chrome */
		{
		from {
			padding: 16px 0;
		}

		to {
			padding: 1px 0;
		}
	}

	.header_down {
		padding: 16px 0;
		animation: godown 0.6s;
		-webkit-animation: godown 0.6s;
		box-shadow: 0 0 16px #595b5f;
		/* Safari and Chrome */
	}

	@keyframes godown {
		from {
			padding: 1px 0;
		}

		to {
			padding: 16px 0;
		}
	}

	@-webkit-keyframes godown

	/* Safari and Chrome */
		{
		from {
			padding: 1px 0;
		}

		to {
			padding: 16px 0;
		}
	}

	/* 头部 end */

	.copyright {
		display: block;
		width: 100%;
		position: relative;
		background: #333;
		padding-top: 5px;
		padding-bottom: 5px;
		margin-top: 0;
		margin-bottom: 0;
		color: #696969;
		text-align: center;
	}

	.copyright>.container {}


	.row,
	a {
		color: #5e5a54;
		font-size: 12px;
	}

	.row>a {
		margin-left: 5px;
		margin-right: 5px;
		font-size: 12px;
	}

	.row>a:hover {
		color: #0000FF;
	}

	.my_cnzz {
		display: inline-block;
		margin-right: 10px;
	}




	.el-carousel__item img {
		color: #475669;
		font-size: 14px;
		opacity: 0.75;
		line-height: 150px;
		margin: 0;
	}

	.el-carousel__item:nth-child(2n) {
		background-color: #99a9bf;
	}

	.el-carousel__item:nth-child(2n+1) {
		background-color: #d3dce6;
	}



	.mybody {
		/* background-color: #ecf5ff; */
		background-color: #f9f9f9;
	}

	.left {
		display: flex;
		background-color: #f9f9f9;
		width: 180px;
		height: auto;
		text-align: center;
		position: relative;
		overflow-y: auto;
		overflow-x: hidden;
		/* border: 1px solid rgb(51, 201, 238); */
		/* padding-bottom: 20px; */
		box-sizing: border-box;
	}

	.left_title {
		height: 60px;

	}

	.left_title>h4,
	.left_title>h5 {
		text-align: center;
	}

	.left_menu {

		overflow-x: hidden;
		overflow-y: auto;
	}

	.right {
		display: flex;

		/* border: 1px solid rgb(53, 187, 211); */
		/* padding-left: 10px; */
		width: calc(100% - 180px);
		height: auto;
		/* padding-top: 6px; */
		box-sizing: border-box;
		padding: 0;
		overflow-y: auto;

	}

	.mright_menu {
		/* border-bottom: 1px solid; */
	}

	/* 中间横向菜单 start */
	.menu-top-ok {
		margin-top: 42px;
		animation: menutop 0.6s;
		-webkit-animation: menutop 0.6s;
		/* Safari and Chrome */
	}

	@keyframes menutop {
		from {
			margin-top: 0px;
		}

		to {
			margin-top: 42px;
		}
	}

	@-webkit-keyframes menutop

	/* Safari and Chrome */
		{
		from {
			margin-top: 0px;
		}

		to {
			margin-top: 42px;
		}
	}


	.mright_down {
		display: inline-block;
		width: 100%;
		/* border-top: 5px groove #897f7f8a;
	  margin-top: -15px; */
	}

	.menu-top-no {
		margin-top: 0px;
		animation: menutopno 0.6s;
		-webkit-animation: menutopno 0.6s;
		/* Safari and Chrome */
	}

	@keyframes menutopno {
		from {
			margin-top: 42px;
		}

		to {
			margin-top: 0px;
		}
	}

	@-webkit-keyframes menutopno

	/* Safari and Chrome */
		{
		from {
			margin-top: 42px;
		}

		to {
			margin-top: 0px;
		}
	}

	/* 定义侧边栏滑动效果 start */
	.left_ok {
		width: 180px;
		animation: goright 0.6s;
		-webkit-animation: goright 0.6s;
	}

	@keyframes goright {
		from {
			width: 0px;
		}

		to {
			width: 180px;
		}
	}

	@-webkit-keyframes goright

	/* Safari and Chrome */
		{
		from {
			width: 0px;
		}

		to {
			width: 180px;
		}
	}

	.left_no {
		width: 0px;
		animation: goleft 0.6s;
		-webkit-animation: goleft 0.6s;
	}

	@keyframes goleft {
		from {
			width: 180px;
		}

		to {
			width: 0px;
		}
	}

	@-webkit-keyframes goleft {
		from {
			width: 180px;
		}

		to {
			width: 0px;
		}
	}

	.right_ok {
		width: calc(100% - 180px);
		animation: small 0.6s;
		-webkit-animation: small 0.6s;
	}

	@keyframes small {
		from {
			width: calc(100% - 0px);
		}

		to {
			width: calc(100% - 180px);
		}
	}

	@-webkit-keyframes small {
		from {
			width: calc(100% -0px);
		}

		to {
			width: calc(100% - 180px);
		}
	}

	.right_no {
		width: calc(100% - 2px);
		animation: big 0.6s;
		-webkit-animation: big 0.6s;
	}

	@keyframes big {
		from {
			width: calc(100% - 180px);
		}

		to {
			width: calc(100% - 2px);
		}
	}

	@-webkit-keyframes big {
		from {
			width: calc(100% - 180px);
		}

		to {
			width: calc(100% - 2px);
		}
	}

	/* 定义侧边栏滑动效果 end */

	.top {
		height: auto;
		background-color: aliceblue;
		padding-top: 2px;
		padding-bottom: 2px;
		padding-left: 10px;
		margin-left: -10px;
	}




	.help-search {}

	.search-btn {
		display: flex;
		/* padding-bottom: 6px; */
		align-items: center;
		/* width: 66%; */
		min-width: 488px;
		max-width: 666px;
		/* background-color: #dcdfe6; */
		height: 36px;
		justify-content: center;

	}

	.s-input {
		-webkit-appearance: none;
		/* background-color: #fff; */
		background-image: none;
		border-radius: 16px;
		border: 1px solid #bec0c6;
		box-sizing: border-box;
		color: #000000;
		display: inline-block;
		font-size: inherit;
		width: 96%;
		height: 32px;
		line-height: 32px;
		outline: none;
		/* margin: 0px; */
		padding: 0px 2px 0px 20px;
		transition: border-color .2s cubic-bezier(.645, .045, .355, 1);
		/* width: 100%; */
		/* border-radius: 5px; */
		font: 400 16px "宋体";
		vertical-align: top;
		margin-right: 6px;
	}

	.s-menu {
		display: flex;
		height: 28px;
		width: 28px;
		line-height: 28px;
		color: #0000ff;
		text-align: right;
		font-family: texticons;
		cursor: pointer;
		min-width: 28px;
		justify-content: center;
		align-items: center;
	}

	.s-txt {
		display: flex;
		height: 28px;
		line-height: 28px;
		color: #ff0000;
		text-align: center;
		font-family: texticons;
		cursor: pointer;
		width: 66px;
		font-size: 12px;
		align-items: center;
		justify-content: center;
	}

	.s-menu:hover,
	.s-txt:hover {
		background-color: #bbbdc2;
		border-radius: 8px;
	}

	/* 搜索 end */

	/* 全局设定 */
	.tan-set div {
		margin-bottom: 8px;
	}

	/* 网站变灰 */
	.gray {
		-webkit-filter: grayscale(100%);
		-moz-filter: grayscale(100%);
		-ms-filter: grayscale(100%);
		-o-filter: grayscale(100%);
		filter: grayscale(100%);
		filter: progid:DXImageTransform.Microsoft.BasicImage(grayscale=1);
	}

	/* 二维码 */
	.kf-erweima img {
		height: 200px;
		width: auto;
	}

	.kf-row span {
		display: inline-flex;
		justify-content: flex-end;
		width: 72px;
		font-size: 14px;
		font-weight: bold;
	}

	.kf-row label {
		display: inline-flex;
		justify-content: flex-start;
		text-align: left;
		font-size: 14px;
		font-weight: 500;
	}
</style>